import { createSlice } from '@reduxjs/toolkit';

const requestMetaSlice = createSlice({
  name: 'requestMeta',
  initialState: {
    requestCompleted: false,
    requestSubmitted: false,
  },
  reducers: {
    setCompletedState: (state, { payload }) => {
      state.requestCompleted = payload;
    },
    setSubmittedState: (state, { payload }) => {
      state.requestSubmitted = payload;
    },
  },
});

export const { setCompletedState, setSubmittedState } = requestMetaSlice.actions;
export default requestMetaSlice.reducer;
